import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { FilterVM, setSortByValue, setFilterValue } from './FilterVM';
import { Container, Row, Col } from 'reactstrap';
import { InputSearch } from 'cd-eft/components/common/InputSearch';
import stores from 'cd-eft/models/Stores';
import './Filter.scss';

const libraryStore = stores.AppStore.projectsLibraryStore;

const FilterComponent = (props) => {
  const vm = useRef(new FilterVM(props)).current;

  return (
    <div className="project-library__filter">
      <form onSubmit={vm.onSubmitForm}>
        <Container fluid className="pl-0">
          <Row className="justify-content-end p-0">
            <Col className="pr-2">
              <div className="input-group justify-content-end">
                <InputSearch
                  name="filterString"
                  setSearchValue={setFilterValue}
                  searchString={libraryStore.filterString}
                  placeholder="Search by Project Name"
                />
              </div>
            </Col>
            <Col className="nogrow pl-0 pr-0">
              <div className="form-row-fixed-height">
                <button className="usa-button nobr mr-0" onClick={vm.onClickAdvansedSearch}>
                  Filter
                </button>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-end">
            <Col className="nogrow">
              <div className="form-row-fixed-height select-border">
                {/* <label className="usa-label " htmlFor="showPerPage"></label> */}
                <select
                  className="usa-select showPerPage"
                  name="showPerPage"
                  data-testid="showPerPage"
                  aria-label="Select show per page"
                  onChange={vm.setLimitPerPage}
                  value={libraryStore.limitPerPage}
                >
                  <option value={5}>Show per page: 5</option>
                  <option value={10}>Show per page: 10</option>
                  <option value={25}>Show per page: 25</option>
                  <option value={50}>Show per page: 50</option>
                  <option value={100}>Show per page: 100</option>
                </select>
              </div>
            </Col>
            <Col className="nogrow pr-0">
              <div className="form-row-fixed-height select-border select-sort-by">
                {/* <label className="usa-label" htmlFor="sortBy"></label> */}
                <select
                  className="usa-select pr-4"
                  name="sortBy"
                  data-testid="sortBy"
                  aria-label="Select sort by"
                  onChange={setSortByValue}
                  value={libraryStore.sortBy > 0 ? libraryStore.sortBy : 3}
                >
                  <option value={1}>Sort by Project Name: Ascending</option>
                  <option value={2}>Sort by Date: Ascending</option>
                  <option value={3}>Sort by Date: Descending</option>
                </select>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
    </div>
  );
};

export const Filter = observer(FilterComponent);
